<template lang="html">
  <div class="colorbars">
    <div v-for="x in colors" :key="x" class="bar" :style="{ background: x }"></div>
  </div>
  <div class="labels">
    <div v-for="x in ticks" :key="x" class="number">{{ x }}</div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import * as d3 from 'd3'

// import { settings } from '../../constants/settings'

export default {
  name: 'VulnerabilityLegend',

  props: {
  },

  data() {
    return {
    }
  },

  computed: {
    d3() {
      return d3
    },
    ...mapState([
      'acsPlaces',
      'vulnerabilityMetric',
    ]),
    ...mapGetters([
      'vulnerabilityColors',
      'vulnerabilityColorBreaks',
    ]),
    breaks() {
      return [...this.vulnerabilityColorBreaks, 1]
    },
    ticks() {
      return this.breaks?.map(d3.format(".1~%"))
    },
    colors() {
      return this.vulnerabilityColors
    }
  },
}
</script>

<style lang="scss" scoped>
.legend {
}
.colorbars {
  display: flex;
}
.labels {
  display: flex;
  margin-top: 2px;
  justify-content: space-between;
}
.number {
  width: 30px;
  font-size: 12px;
}
.bar {
  flex-grow: 1;
  width: 1px;
  height: 20px;
  text-align: center;

  &.short {
    height: 9px;
  }
}
</style>